import { styled, Box, StyleSystemProps, Flex } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';

export const StyledSelectPurchaseOptionsWrapper = styled(Box)``;

export const selectPurchaseOptionsStyles: StyleSystemProps = {
  paddingY: 4,
  borderTopColor: 'mono3',
  borderTopStyle: 'solid',
  borderTopWidth: pxToRem(1),
  cursor: 'pointer',
};

export const StyledOptionWrapper = styled(Flex)``;

export const optionStyles = (isChecked: boolean, isDisabled: boolean): StyleSystemProps => {
  return {
    padding: 5,
    borderColor: isChecked && !isDisabled ? 'mono14' : 'mono3',
    borderStyle: 'solid',
    borderWidth: isChecked ? pxToRem(2) : pxToRem(1),
    backgroundColor: isDisabled ? 'mono1' : 'transparent',
    borderRadius: 1,
    marginY: 4,
  };
};
